export default "__VITE_ASSET__BgHsB6Qm__"